import {Box, Link, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {LINKS} from '@/constants/LinksConstants';

import {FdicIcon} from './FdicIcon';

export function SplitsDisclaimer() {
  const {t} = useTranslation();

  return (
    <Box className="splits-landing-disclaimer">
      <Typography className="splits-landing-disclaimer-text">
        {t('payment_link_v2.success.disclaimer.deposit_account')}
      </Typography>

      <Typography className="splits-landing-disclaimer-text">
        {'* '}
        <Link
          href={LINKS.REFERRAL_PROGRAM}
          className="splits-landing-disclaimer-link"
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          color="inherit">
          {t('payment_link_v2.success.disclaimer.referral_program')}
        </Link>
        {t('payment_link_v2.success.disclaimer.terms_conditions')}
      </Typography>
      <Typography className="splits-landing-disclaimer-text mt-24">
        {t('payment_link_v2.success.disclaimer.text')}
        <Link
          href={LINKS.CONSUMER_ACCOUNT_CARD_HOLDER_AGREEMENT}
          className="splits-landing-disclaimer-link"
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          color="inherit">
          {t('payment_link_v2.success.disclaimer.link')}
        </Link>
      </Typography>
      <Box className="splits-landing-fdic-footer">
        <FdicIcon />
      </Box>
      <Typography className="splits-landing-disclaimer-text">
        {t('payment_link_v2.success.disclaimer.rating')}
      </Typography>
    </Box>
  );
}
